import { __ } from '@wordpress/i18n'

export default function Nav (props) {
  return (
    <div
      className={'wp-block-gds-lead-form__nav'}
    >

      {(props.onBack || props.backDisabled) ? (
        <button
          type="button"
          className="wp-block-button__link wp-element-button"
          disabled={props.backDisabled}
          onClick={props.onBack}
        >
          {props.backLabel || __('Takaisin', 'gds')}
        </button>
      ) : <div/>}

      {(props.onNext || props.nextDisabled) ? (
        <button
          type="button"
          className="wp-block-button__link wp-element-button"
          disabled={props.nextDisabled}
          onClick={props.onNext}
        >
          {props.nextLabel || __('Seuraava', 'gds')}
        </button>
      ) : <div/>}
    </div>
  );
}
